import React, { Component } from 'react'
import { compose } from 'recompose'
import { meta } from '../../../helpers/decorators'
import { apiCommon } from '../../../helpers/decorators/api'
import ImportOfflineParticipants from '../../forms/support/ImportOfflineParticipants/ImportOfflineParticipants'
import ImportInvitedParticipants from '../../forms/support/ImportInvitedParticipants/ImportInvitedParticipants'

const enhance = compose(
  meta({
    id: 'pageTitle.manual_data_import',
    defaultMessage: 'Manual data import'
  }),
  apiCommon({ locales: true }),
)

class DataImport extends Component {
  render() {
    return (
      <div>
        <ImportOfflineParticipants />
        <ImportInvitedParticipants />
      </div>
    )
  }
}

export default enhance(DataImport)
